<template>
  <div class="devOps_producerSpaceOther" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="项目体系" prop="project_system" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle"   v-model="form.systemId" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需求名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.demandName" />
      </el-form-item>
      <el-form-item label="开发任务">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.devTaskName" />
      </el-form-item>
      <el-form-item label="测试名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.testTaskName" />
      </el-form-item>
      <el-form-item label="缺陷名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.bugName" />
      </el-form-item>
      <el-form-item label="创建人" prop="creator" :label-width="formLabelWidth">
        <el-select :style="iptStyle"  multiple filterable collapse-tags size="mini" v-model="form.creatorId"  placeholder="请选择产品经理">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="负责人" prop="leading" :label-width="formLabelWidth">
        <el-select :style="iptStyle"  multiple filterable collapse-tags size="mini" v-model="form.ownerId"  placeholder="请选择产品经理">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="环境">
        <el-select :style="iptStyle" collapse-tags v-model="form.type" multiple filterable
                   placeholder="请选择">
          <el-option v-for="(item, index) in BUGTYPE" :key="index" :label="item"
                     :value="index" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优先级">
        <el-select :style="iptStyle" collapse-tags v-model="form.priority" multiple filterable
                   placeholder="请选择">
          <el-option v-for="(value, key) in allSelect.BUGTASHOPERATOR" :key="key" :label="key" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select :style="iptStyle" multiple filterable collapse-tags v-model="form.status"
                   placeholder="请选择">
          <el-option v-for="(value, key) in allStatusList.ALLSTATUSTYPE5" :key="value" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="实际完成日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
      <div class="upload-box">
        <el-form-item>
          <el-button v-if="allMenuList.btn_bug_query" style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_bug_add" style="font-weight: bold;letter-spacing: 2px;font-size: 12px;" type="primary"
                     @click="showDialogVisible('create', {})">新增缺陷
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_bug_clear" style="font-weight: bold;letter-spacing: 2px;font-size: 12px;" type="primary"
                     @click="changeReset()">置空
          </el-button>
        </el-form-item>
        <el-upload
            v-if="allMenuList.btn_bug_add_batch"
            class="upload"
            action="#"
            :show-file-list="false"
            :on-change="handleExcel"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :auto-upload="false"
            :headers="headers">
          <el-button style="font-weight: bold;letter-spacing: 2px;font-size: 12px;padding: 7px 17px;margin-left: 10px;margin-bottom: 10px;" type="primary">批量导入</el-button>
        </el-upload>
        <div v-if="allMenuList.btn_bug_add_batch" slot="tip" class="el-upload__tip">（请先下载模板文件，<span @click.stop="downloadd" class="down-xsl">点击下载模板</span>）</div>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 58vh;position: relative;">
      <el-table height="100%" stripe :header-cell-style="getCellClass" row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column fixed="left" prop="db_title" min-width="120" label="缺陷名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('create', scope.row)" class="table_text_click_new" v-if="scope.row.id">
              [{{ scope.row.id }}] {{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="statusDesc"  align="center" width="60" label="状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="projectSystemName" align="center" width="120" label="项目体系" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column  prop="demand_name" min-width="120" label="需求名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('demand', scope.row)" class="table_text_click_new">
             [{{scope.row.demand_id}}]  {{ scope.row.demand_name }}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="test_name" min-width="120" label="测试任务" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('addTest', scope.row)" class="table_text_click_new">
            [{{scope.row.test_id}}]  {{ scope.row.test_name }}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="developer_name" min-width="120" label="开发任务" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('task', scope.row)" class="table_text_click_new">
               [{{scope.row.developer_id}}]{{ scope.row.developer_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="task_type" align="center" width="80" label="环境" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span> {{ BUGTYPE[scope.row.task_type]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="priority" align="center" width="62" label="优先级" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="priority_style" :style="allSelect.COLORPRIORITY[scope.row.priority]">
              {{ scope.row.priority }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="creator_id" align="center" width="80" label="创建人" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.creator_id.nameZh ? scope.row.creator_id.nameZh: '' }} {{ scope.row.creator_id.nameEn ? '('+scope.row.creator_id.nameEn+')': '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="owner_id" label="负责人" width="90" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.owner_id.nameZh ? scope.row.owner_id.nameZh: '' }} {{ scope.row.owner_id.nameEn ? '('+scope.row.owner_id.nameEn+')': '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" sortable="custom" align="center" width="130" label="创建时间" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="finishDate" sortable="custom" align="center" width="130" label="实际完成日期" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->

    <!-- #region 分页部分 -->
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
    <!-- #endregion -->
    <!-- #region dialog 部分 -->
    <create v-if="dialogVisible.create" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.create'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <pending_processing v-if="dialogVisible.pending_processing" :dialogVisible='dialogVisible.pending_processing'
                        :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <to_be_submitted v-if="dialogVisible.to_be_submitted" :dialogVisible='dialogVisible.to_be_submitted'
                     :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <to_be_verified v-if="dialogVisible.to_be_verified" :dialogVisible='dialogVisible.to_be_verified' :hideDialogVisible="hideDialogVisible"
                    :formInfo="checkedInfo" />
    <!--    <TaskBug v-if="dialogVisible.task" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
              :formInfo="checkedInfo" />-->
    <Demand v-if="dialogVisible.demand" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.demand'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :tabid="tabid"/>
    <Task v-if="dialogVisible.task" :back="back" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
          :formInfo="checkedInfo" :tabid="tabid"/>
    <TestTask v-if="dialogVisible.addTest" :dialogVisible='dialogVisible.addTest' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"/>

    <!-- #endregion dialog 部分 -->
    <Menu />
  </div>
</template>
<script>
import {Demand, Task, TaskBug} from './components'
import { create, pending_processing, to_be_submitted, to_be_verified } from './components/bug'
import { postDevOpsSpaceAllBugTaskApi, getDevOpsSpaceStageSelectmapApi, postDevOpsSpaceBugExcelTaskApi } from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
import TestTask from "@/views/tops/devOps/producerSpace/components/testTask.vue";
export default {
  components: {Task, Demand, TestTask, create, pending_processing, to_be_submitted, to_be_verified, TaskBug,  Menu },
  data() {
    return {
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8"},
      // 表单搜索条件
      form: {
        status:['0','1','2'],
        task_type:[],
        creator:[],
        leading:[],
        severity:[],
        serach_time:'',
        task_name:'',
        ownerId: '',
        systemId: '',
        demandName: '',
        devTaskName: '',
        testTaskName: '',
        bugName: '',
        creatorId: '',
        type: '',
        priority: '',
      },
      // 列表
      tableData: [],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        create: false,
        pending_processing: false,
        to_be_submitted: false,
        to_be_verified: false,
        task: false,
        addTest: false,
        demand: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      tableLoading: false,
      login_username: '',
    };
  },
  async created() {
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.users = this.allSelect.TEXTUSERSEN;
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsWorkOrderConfig')
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          BUGTYPE: (state) => state.devOps.BUGTYPE,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
    /*覅责任*/
    creatorStr() {
      let str = ''
      this.form.creator.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },

    /*覅责任*/
    leadingStr() {
      let str = ''
      this.form.leading.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },

    /*任务类型*/
    typetaskStr() {
      let str = ''
      this.form.task_type.forEach(item => {
        str += item + ' '
      })
      return str;
    },
    /*严重程度*/
    severityStr() {
      let str = ''
      this.form.severity.forEach(item => {
        str += this.allSelect.BUGTASKPRIORITY[item] + ' '
      })
      return str;
    },
    /*任务状态*/
    statustaskStr() {
      let str = ''
      if(this.allSelect.BUGTASKSTATUS){
        this.form.status.forEach(item => {
          str += this.allSelect.BUGTASKSTATUS[item] + ' '
        })
      }
      return str;
    },
    isCreateUser() {
      const roles = this.allUserList['MYROLES']
      if(roles[4]){
        return true;
      }
      return false;
    },
  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { pid = '', tid = '', testId = '',bid = '',ns = '',isdev = '',istest = '',ids = '', tabid  = ''} = this.$route.query;

    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : []};
    this.login_username = username;
    /*
        if(create_task_id){
          this.form.task_name = create_task_id;
        }*/
    /*if(type_status == 1){
      this.form.status = ['pending_processing','to_be_submitted','to_be_verified'];
    }*/
    /*    if(db_id){
          this.form.title = db_id;
        }*/
    this.$nextTick(async () => {
      await this.formSearch();
      // this.autoDialogDetailPop(this.tableData)
    })
    if(this.$store.state.devOps.userInfo.userId){
      // let defauleUserId = this.allUserList.ALLUSERIDLIST1[username];
      let defauleUserId = this.$store.state.devOps.userInfo.userId;
      if(this.isCreateUser){
        this.form.creatorId = [defauleUserId.toString()];
      }else{
        this.form.ownerId = [defauleUserId.toString()];
      }
      // this.form.creatorId = [defauleUserId.toString()];
      //this.form.ownerId = [defauleUserId.toString()];
    }

    if (pid || tid || bid || testId) {
      this.form.status = '';
      this.form.ownerId = '';
      this.form.creatorId = '';
      if(pid) this.form.demandName = pid;
      if(tid) this.form.devTaskName = tid;
      if(bid) this.form.bugName = bid;
      if(testId) this.form.testTaskName = testId;
    }
    if(ns && ns == 8){
      this.form.status = ['3'];
    }
    if(ns && ns == 9){
      this.form.status = '';
      this.form.ownerId = '';
      if(this.allUserList.ALLUSERIDLIST1[username]){
        let defauleUserId = this.allUserList.ALLUSERIDLIST1[username];
        this.form.creatorId = [defauleUserId.toString()];
      }
    }
    if (ids) {
      this.form.status = '';
      this.form.ownerId = '';
      this.form.creatorId = '';
      this.form.bugName = ids;
    }
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 判断任务状态是否已完成
    taskStatusDisabledFn(state,leading,creator) {
      if(this.login_username === 'joseph_ji'){
        return true;
      }
      if(state === 'completed'){
        return false;
      }
      if(state === 'to_be_submitted' || state === 'pending_processing'){
        if(this.login_username ===leading){
          return true;
        }
      }
      if(state === 'to_be_verified'){
        if(this.login_username === creator){
          return true;
        }
      }
      return false;
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表单搜索
    async formSearch(type,key) {
      this.form.finishDateStart='';
      this.form.finishDateEnd='';
      if(this.form.serach_time){
        if(this.form.serach_time[0]){
          this.form.finishDateStart=this.form.serach_time[0];
        }
        if(this.form.serach_time[1]){
          this.form.finishDateEnd=this.form.serach_time[1];

        }
      }
      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await postDevOpsSpaceAllBugTaskApi(params);
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    autoDialogDetailPop(tableData){
      const { taskid = '',db_id = '' } = this.$route.query;
      if (!tableData.length) return;
      if (taskid) { // 弹阶段详情
        if(tableData[0].db_status ==='pending_processing' || tableData[0].db_status === 'to_be_submitted' || tableData[0].db_status === 'to_be_verified'){
          this.showDialogVisible(tableData[0].db_status, tableData[0])
        }else{
          this.showDialogVisible('create', tableData[0])
        }

        return;
      }
      if(db_id){
        this.showDialogVisible('create', tableData[0])
      }
      return;
    },

    // 格式化数据
    formatTableData(data) {
      let arr = []
      data.forEach((t, i) => {
        let obj = {
          d_title:t.d_title,
          act_end_time:t.act_end_time,
          db_creator:t.db_creator,
          db_id:t.db_id,
          id:t.db_id,
          db_leading:t.db_leading,
          db_module:t.db_module,
          project_system:t.project_system,
          db_plet:t.db_plet,
          db_plt:t.db_plt,
          db_priority:t.db_priority ,
          db_related_task_id:t.db_related_task_id,
          db_severity:t.db_severity,
          db_status:t.db_status,
          db_task_type:t.db_task_type,
          db_title: t.db_title,
          db_context: t.db_context,
          db_operator_context: t.db_operator_context,
          operator_context:t.db_operator_context,
          taskInfo: {
            id: t.db_related_task_id,
          }
        };
        /*  if (i === 0) {
            obj = { ...obj,  ...this.commonTableDataObj(t) }
          }*/
        arr.push(obj)
      })

      return arr;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { title, id, user_pm, priority, p_status, p_issue_status, plt, progress, plan_progress, demander, project_system ,reviewed_status} = o;
      return { title, id, user_pm, priority, p_status, p_issue_status, plt, progress, plan_progress, demander, project_system,reviewed_status }
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    // 排序任务时间
    sortTaskTime(key, order) {
      let arr = this.formatSortTableData();
      let newArr = []
      arr.forEach(item => {
        let existDates = [], noExistDates = [];
        let maxDate = 0; // 找出最大日期
        item.forEach(t => {
          const currentDate = t.taskInfo[key];
          if (currentDate && maxDate < currentDate) {
            maxDate = currentDate
          }
          t.taskInfo[key] ? existDates.push(t) : noExistDates.push(t);
        })
        existDates.sort((a, b) => {
          return order === 'descending' ? b.taskInfo[key] - a.taskInfo[key] : a.taskInfo[key] - b.taskInfo[key];
        })
        let tArr = existDates.concat(noExistDates);
        let newTArr = []
        tArr.forEach((t, i) => {
          newTArr.push(i === 0 ? { ...t, maxDate } : t)
        })
        newArr.push(newTArr);
      })
      this.tableData = this.setTableDateHead(newArr, order)
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    sortChange(column) {
      const { prop, order } = column;

      if(prop === 'createTime') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.createTime) - Date.parse(a.createTime) : Date.parse(a.createTime) - Date.parse(b.createTime);
        })
      }
      if(prop === 'planFinishDate') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.planFinishDate) - Date.parse(a.planFinishDate) : Date.parse(a.planFinishDate) - Date.parse(b.planFinishDate);
        })
      }
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      let newRow = {...row};
      if (type === 'releaseing') {
        return;
      }
      if(type === 'addTest'){
        newRow = {...row,taskInfo:{id:row.test_id}};
      }
      if(type === 'task'){
        if(!row.taskId){
          newRow = {...row,taskId:row.developer_id}
        }
      }
      if(type === 'demand'){
        newRow = {name : row.demandName, id: row.demand_id}
      }
      //await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[type] = true;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        //const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : {}
        const params = { title: this.checkedInfo?.id};
        const ret = await postDevOpsSpaceAllBugTaskApi(params);
        const tableData = ret.data || [];
        this.checkedInfo = tableData[0];
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    handleExcel(file) {
      this.loading = true;
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("bug_file", file.raw);    //把文件信息放入对象中
      //调用后台导入的接口
      postDevOpsSpaceBugExcelTaskApi(formData).then(res => {
        if (res.status === 'sucess') {
          this.$message({
            type: 'success',
            message: res.data.msg || '导入成功'
          })
          this.loading = false;
          this.formSearch();
        } else {
          this.$message({
            type: 'error',
            message: res.data.data.output || '导入失败'
          })
          this.loading = false;
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          message: err || '导入失败'
        })
        this.loading = false;
      })
    },
    changeReset(){
      this.form.status = '';
      this.form.ownerId = '';
      this.form.systemId = '';
      this.form.demandName = '';
      this.form.devTaskName = '';
      this.form.testTaskName = '';
      this.form.bugName = '';
      this.form.creatorId = '';
      this.form.type = '';
      this.form.priority = '';
      this.form.serach_time = '';
    },
    //点击下载
    downloadd() {
      let a = document.createElement('a') // 创建一个<a></a>标签
      a.href = 'https://tops2-static.ehsy.com/devops/test/Bug.xlsx'
      a.download = 'Bug批量导入模板.xlsx'         // 设置下载文件文件名
      a.style.display = 'none'           // 隐藏a标签
      document.body.appendChild(a)       // 将a标签追加到文档对象中
      a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove()                        // 用完就删除a标签
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceOther {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_producerSpaceOther .el-form-item__label{
  font-weight: bold;
  font-size: 12px;
}
.upload-box{
  display: flex;
}
.down-xsl{
  cursor: pointer;
  color: #409EFF;
}
</style>
